import type { MappedFlight } from '../types';

export const getUniqueAirlines = (flight: MappedFlight) => {
  const { segments } = flight;
  const airlinesHashmap = segments.reduce(
    (acc, { displayAirline, airlineTitle }) => {
      if (!acc[displayAirline]) {
        acc[displayAirline] = airlineTitle;
      }
      return acc;
    },
    {} as Record<string, string>,
  );
  return Object.keys(airlinesHashmap).map(iata => ({
    iata,
    title: airlinesHashmap[iata],
  }));
};
